import setReportingData from './setReportingData'

export default {
  setReportingData,
}
